import './events.less'

import {DOMAttrs} from '@codeurs/front'
import logoImec from 'assets/images/imec-logo-white.svg'
import React, {useState} from 'react'
import {Fragments} from 'views/layout/animation/fragments'
import {ImageOrSvgType, LinkType, PageData, WysiwygType} from '../../types'
import {style} from '../../util/style'
import {Trusted} from '../../util/trusted'

export type EventsItemType = {
	title: WysiwygType
	subtitle: WysiwygType
	link: LinkType
	logo?: ImageOrSvgType
	description: WysiwygType
}

const styles = style('events', ['item'])

export const Events: React.FC<PageData & {
	title: string
	logo?: ImageOrSvgType
	description?: WysiwygType
	events: Array<EventsItemType>
}> = data => {
	const [selected, setSelected] = useState<EventsItemType>(null)
	const {logo, description, events} = data

	const defaultDescription = `
        ITF brings together premium stakeholders from the global semiconductor,
        ICT and high-tech industry including business leaders, innovation managers,
        policy makers, academia, entrepreneurs, investors and technology gurus.
		`

	return (
		<div className={styles()}>
			<div className={styles('fragments')}>
				<Fragments theme={selected ? 'itfbelgium' : null} />
			</div>
			<div className={styles('scroller')}>
				<div className={styles('container')}>
					<div className={styles('center')}>
						<div className={styles('logo')}>
							<div className={styles('logo-block')}>
								<div className={styles('logo-block-img')}>
									{(selected || logo) && (
										<img
											src={
												selected
													? fileOrImagePath(selected.logo)
													: fileOrImagePath(logo)
											}
											alt="Logo ITF"
										/>
									)}
								</div>
								<div className={styles('logo-block-text')}>
									<Trusted>
										{selected?.description || description || defaultDescription}
									</Trusted>
								</div>
							</div>
						</div>
						<div className={styles('events')}>
							{events.map(event => (
								<EventsItem
									item={event}
									onMouseOver={() => setSelected(event)}
								/>
							))}
						</div>
					</div>
					<div className={styles('logoimec')}>
						<div className={styles('logoimec-text')}>powered by</div>
						<div className={styles('logoimec-img')}>
							<a
								href="https://www.imec-int.com/"
								target="_blank"
								className={styles('logoimec')}
							>
								<img src={logoImec.src} />
							</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}
export const EventsItem: React.FC<{
	item: EventsItemType
} & DOMAttrs> = ({item, ...attrs}) => {
	let View = 'div'
	let linkAttrs: any = {}

	if (item.link) {
		View = 'a'
		linkAttrs = {
			href: item.link.url,
			target: '_self'
		}
	}

	const subtitlePieces = (item.subtitle || '')
		.split('<br />')
		.map(piece => piece.replace('<p>', '').replace('</p>', ''))

	return (
		<View className={styles.item()} {...attrs} {...linkAttrs}>
			<div className={styles.item('title')}>
				<Trusted>{item.title}</Trusted>
			</div>
			<div className={styles.item('subtitle')}>
				{subtitlePieces.map(piece => (
					<Trusted>{`<p>${piece}</p>`}</Trusted>
				))}
			</div>
		</View>
	)
}

const fileOrImagePath: (ImageOrSvgType) => string = input =>
	input && (input.src || input.url)
